import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Import helpers
import { initGA, initGTM, initPixel, recordPageView } from 'helpers/tracking';

// Import utilities
import { useAuth } from 'components/utilities';

const useAppTemplate = () => {
	const { pathname } = useLocation();
	const { isAuth } = useAuth();

	useEffect(() => {
		initGTM();
		initGA();
		initPixel();
	}, []);

	useEffect(() => {
		recordPageView();
	}, [pathname]);

	return { isAuth };
};

export default useAppTemplate;
